export const loadDependencies = () => {
  // TODO: laod fonts in webpack
  loadCss("https://swisnl.github.io/jQuery-contextMenu/dist/jquery.contextMenu.css");
  loadCss("//golden-layout.com/assets/css/goldenlayout-base.css");
  loadCss("//golden-layout.com/assets/css/goldenlayout-dark-theme.css");
  loadCss(
    "https://oliver-ssl-assets.s3.amazonaws.com/Ixcanul_dependencies/fine-uploader-gallery/fine-uploader-gallery.min.css"
  );
};

export const loadCss = url => {
  let file;
  file = document.createElement("link");
  file.setAttribute("rel", "stylesheet");
  file.setAttribute("type", "text/css");
  file.setAttribute("href", url);
  $("head").append(file);
};
/**
 * loadJS(string) attaches a script tag to the body
 * @param {string} url the url to the dependency
 */
export const loadJS = url => {
  let script;
  script = document.createElement("script");
  script.type = "application/javascript";
  script.src = url;
  document.body.appendChild(script);
};
